




















































































import qrcode from "./qrcode.vue";
import { Vue, Component } from "vue-property-decorator";
import { TradeMode } from "@/model/Base";
import billService from "@/service/billService";
import { removeKeepalive } from "../modules/keepUtils";
import axios from "axios";

@Component({
  name: "cashier",
  components: {
    qrcode,
  },
  filters: {
    paymentIcon(typeCode: string) {
      return `/static/img/${typeCode}.png`;
    },
  },
})
export default class extends Vue {
  CashierInfo = {};
  OrderInfo = {};
  TradeModes = [];
  model = {
    OrderID: "",
    TradeIds: [],
    TradeMode: TradeMode.Alipay,
    TradeType: "",
    PackageID: "",
    ServiceType: "",
    UniqueID: "",
  };
  isPay = false;
  showdialog = false;
  qrdata = "";
  clickCount = 0;
  get isShowTest() {
    return this.clickCount >= 3 && (location.href.indexOf("test") > -1 || location.href.indexOf("web.ecs.net") > -1);
  }

  get OrderID(): string {
    return this.$route.query.OrderID as string;
  }

  mounted() {
    let __self = this;
    __self.__init();
  }

  TradeInfos: any[] = [];
  __init() {
    let __self = this;
    __self.model.TradeMode = TradeMode.WeChat;
    billService.cashier(__self.$route.query).then(function(json) {
      if (json.isSucc) {
        let result = json.result;
        let cashierInfo = result.CashierInfo;
        __self.CashierInfo = cashierInfo;
        __self.OrderInfo = result.OrderInfo;
        __self.TradeInfos = result.TradeInfos;
        __self.TradeModes = (result.TradeModes || []).filter((o: any) => o.ModeID == TradeMode.WeChat || o.ModeID == TradeMode.Alipay);
        __self.model.TradeIds = result.TradeIds;
        __self.model.OrderID = result.CashierInfo.OrderID;
        __self.model.PackageID = cashierInfo.PackageID;
        __self.model.ServiceType = cashierInfo.ProductType;
        __self.model.UniqueID = cashierInfo.UniqueID;
      }
    });
  }
  redirect() {
    let __self = this;
    __self.model.OrderID = __self.OrderID;
    if (__self.isPay) {
      return;
    }
    let query = __self.$route.query;
    let model = __self.model as any;
    for (const key in query) {
      if (query.hasOwnProperty(key)) {
        model[key] = query[key];
      }
    }
    __self.isPay = true;
    if (model.TradeMode == TradeMode.WeChat) {
      model.TradeType = "MWEB";
    }
    let win = window as any;
    billService.redirect(model).then(json => {
      __self.isPay = false;
      if (!json.isSucc || !json.result) {
        this.$dialog.alert({ message: json.message });
        return;
      }
      var result = json.result;
      if (result.recode) {
        __self.qrdata = result.redirect;
      }
      let userAgent = win.navigator.userAgent;
      if (userAgent.toLowerCase().match(/MicroMessenger/i) == "micromessenger") {
        location.href = json.result.redirect;
      } else {
        if (result.redirect.indexOf("http://") > -1 || result.redirect.indexOf("https://") > -1) {
          location.href = json.result.redirect;
        } else if (win.lch_wechat) {
          win.lch_wechat.pay(result.prepay_id, (json: any) => {
            history.back();
          });
        } else {
          location.href = json.result.redirect;
        }
      }
    });
  }
  ensureFallback(location: any) {
    removeKeepalive(this.$route.fullPath);
    history.replaceState({ target: "index" }, "index", "/");
    this.$router.push(typeof location == "string" ? { path: location } : location);
  }
  runNotify() {
    let OrderID = this.OrderID;
    axios
      .get(`/api/bill/callback/notify?CreateMode=1373&PackageID=${this.model.PackageID}`)
      .catch((error: any) => {
        console.log(error);
      })
      .then((json: any) => {
        console.log(json);
        if (json.data == "success") {
          this.ensureFallback(`/order/details?OrderID=${OrderID}`);
        }
      });
  }
}
